import { get } from '..';
import { applySolveAnalyticsFilters, GetSolveAnalyticsStatsProps } from './Utils';

const GetSLAViolations = (props: GetSolveAnalyticsStatsProps) => {
  const baseUrl: string = 'solve-analytics/sla-violations';
  const url: string = applySolveAnalyticsFilters(baseUrl, props);
  return get(url);
};

export default GetSLAViolations;
